function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4 0V48H28C28.3594 48.0039 28.6953 47.8164 28.8789 47.5039C29.0586 47.1914 29.0586 46.8086 28.8789 46.4961C28.6953 46.1836 28.3594 45.9961 28 46H6V2H24V16H38V35C37.9961 35.3594 38.1836 35.6953 38.4961 35.8789C38.8086 36.0586 39.1914 36.0586 39.5039 35.8789C39.8164 35.6953 40.0039 35.3594 40 35V14.5938L39.7188 14.2812L25.7188 0.28125L25.4062 0H4ZM26 3.4375L36.5625 14H26V3.4375ZM47.6875 27.5312L47.1562 28.3438L35.5 46.4688L27.6875 39.375L26.9375 38.6875L25.5938 40.1562L26.3125 40.8438L35.0312 48.75L35.9062 49.5312L36.5312 48.5312L48.8438 29.4375L49.375 28.5938L47.6875 27.5312Z",
  fill: "currentColor"
});

function SvgCheckFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckFile);
export default __webpack_public_path__ + "static/media/check-file.9b2436fb.svg";
export { ForwardRef as ReactComponent };